export const getStartEndDate = (month, year) => {
    const startDate = new Date(year, month, 1);
    const endDate = new Date(year, month + 1, 0);
    return { startDate, endDate };
  };
  
  export const getTotalTimeSpent = (data, selectedMonth, selectedYear) => {
    if (!data || !data.result) return 0;
  
    const { startDate, endDate } = getStartEndDate(selectedMonth, selectedYear);
  
    return data.result.worklogs.reduce((total, worklog) => {
      if (worklog.labels && worklog.labels.includes('NIESERWISOWE')) {
        return total; 
      }
      return total + worklog.worklogs.reduce((logTotal, log) => {
        const logDate = new Date(log.started);
        if (logDate >= startDate && logDate <= endDate) {
          return logTotal + log.timeSpentSeconds;
        }
        return logTotal;
      }, 0);
    }, 0);
  };
  
  export const getTotalNonServiceTime = (data, selectedMonth, selectedYear) => {
    if (!data || !data.result) return 0;
  
    const { startDate, endDate } = getStartEndDate(selectedMonth, selectedYear);
  
    return data.result.worklogs.reduce((total, worklog) => {
      if (worklog.labels && worklog.labels.includes('NIESERWISOWE')) {
        return total + worklog.worklogs.reduce((logTotal, log) => {
          const logDate = new Date(log.started);
          if (logDate >= startDate && logDate <= endDate) {
            return logTotal + log.timeSpentSeconds;
          }
          return logTotal;
        }, 0);
      }
      return total;
    }, 0);
  };


  export const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
  
    if (hours > 0 && minutes > 0) {
      return `${hours}h ${minutes}min`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else {
      return `${minutes}min`;
    }
  };


  export const parseJiraTime = (estimate) => {
    if (!estimate) return 0;
  
    const timeUnits = {
      w: 5 * 8 * 3600, 
      d: 8 * 3600,     
      h: 3600,      
      m: 60            
    };
  
    return estimate.match(/\d+\w/g)?.reduce((total, part) => {
      const value = parseInt(part, 10);
      const unit = part.replace(/\d+/g, '');
      return total + (timeUnits[unit] ? value * timeUnits[unit] : 0);
    }, 0) || 0;
  };
  

  export const formatDate = (date) => {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  };


  